import './style.scss';
import template from './indonesianActionsPanel.html';
import controller from './indonesianActionsPanelCtrl';

export default {
  template,
  controller,
  controllerAs: 'vm',
};
